import { createEvent, sample } from 'effector'
import { ClientLeverageLimitForm, ClientLeverageLimitRequest } from './types'
import { restore } from 'effector'
import { fx } from '../../../../../../libs'
import { Error } from '../../../../../gateway/edit/types'
import { $params } from '../../../../../../features/router'
export const setClientLeverageLimit = createEvent<ClientLeverageLimitForm>()

export const setClientLeverageLimitError = createEvent<Error>()

export const $accountForm = restore(setClientLeverageLimit, {
  clientId: '',
  leverage: '',
  accountType: '1',
  isUpdateAccounts: false,
  isChangeMTLeverage: false,
})

export const $errorClientLeverageLimit = restore(setClientLeverageLimitError, {
  message: '',
  code: 0,
})

export const updateLeverageLimit = fx<ClientLeverageLimitRequest, void>({
  method: 'POST',
  url: '/client/{client}/leverage_limit',
})

export const submitClientLeverageLimit =
  createEvent<ClientLeverageLimitRequest>()

sample({
  //@ts-ignore
  clock: submitClientLeverageLimit,
  source: $params,
  fn: (params, account) => {
    return {
      url: `/client/leverage_limit`,
      body: { ...account, clientId: params?.clientID },
    }
  },
  target: updateLeverageLimit,
})

sample({
  clock: updateLeverageLimit.doneData,
  fn: () => {
    return {
      clientId: '',
      leverage: '',
      accountType: '1',
      isUpdateAccounts: false,
      isChangeMTLeverage: false,
    }
  },
  target: [setClientLeverageLimit],
})

sample({
  clock: updateLeverageLimit.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setClientLeverageLimitError],
})
